import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TimeDiffPipe } from './pipes/time-diff.pipe';
import { PdatePipe } from "./pipes/pdate.pipe";

const shared = [
  TimeDiffPipe,
  PdatePipe, 
];

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [shared],
  exports: [shared],
})
export class CoreModule { }

export * from './pipes/time-diff.pipe';
export * from './pipes/pdate.pipe';